import React from 'react';
import { Button } from '@material-ui/core';


const sampleData = [
  'Maria,Smith,maria@example.net,1987654320,female,02/07/2001,General\n',
  'John,Dou,john.d@example.com,1234567890,male,10/13/1978,General\n'
];

const DownloadTemplateButton = ({headers}) => {
  const downloadTemplate = () => {
    const fileName = 'import_customers.csv';
    const fileType = 'text/csv';

    const blob = new Blob([`${headers}\n`].concat(sampleData), { type: fileType});

    const a = document.createElement('a');
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  return (
    <Button
      variant="outlined"
      color="primary"
      className="bg-light-blue text-14 font-bold"
      onClick={downloadTemplate}
    >
      Download our CSV Spreadsheet Template
    </Button>
  );
};

export default React.memo(DownloadTemplateButton);
